var map = {
	"./pt-dashboard-01.png": 94154,
	"./pt-dashboard-02.png": 29281,
	"./pt-dashboard-03.png": 89273,
	"./pt-dashboard-04.png": 3093,
	"./specialities-01.png": 65488,
	"./specialities-01.svg": 77964,
	"./specialities-02.png": 99022,
	"./specialities-02.svg": 5031,
	"./specialities-03.png": 25326,
	"./specialities-03.svg": 48404,
	"./specialities-04.png": 21080,
	"./specialities-04.svg": 11178,
	"./specialities-05.png": 48761,
	"./specialities-05.svg": 35555,
	"./specialities-06.svg": 82056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93336;